import { useEffect, useRef, useState } from "react";

export function useElementWidth<T extends HTMLElement>(): [React.RefObject<T | null>, number] {
  const ref = useRef<T | null>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!ref.current) return;
    const handleResize = (entries: ResizeObserverEntry[]) => {
      for (let entry of entries) {
        setWidth(entry.contentRect.width);
      }
    };
    const observer = new ResizeObserver(handleResize);
    observer.observe(ref.current);
    // Set initial width
    setWidth(ref.current.offsetWidth);
    return () => observer.disconnect();
  }, [ref.current]);

  return [ref, width];
}
